import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { FormatDataService } from "../services/format-data.service";
import { PraService } from "../services/pra.service";
import { first } from "rxjs/operators";
import { ngxLoadingAnimationTypes } from "ngx-loading";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { Grid } from "ag-grid";
import { PunchDataModel } from "../pra-confirm-request/dataModel";
//Format Time with momentJS
import * as moment from "moment";
//lodash
import * as _ from "lodash";

@Component({
  selector: "app-pra-confirm-request",
  templateUrl: "./pra-confirm-request.component.html",
  styleUrls: ["./pra-confirm-request.component.css"],
})
export class PraConfirmRequestComponent implements OnInit {
  //Current User
  currentUser: any;

  params: any;
  punchIn: any;
  punchOut: any;
  punchRecords: any;
  comments: string;

  //List
  punchRecordsList: Array<PunchDataModel> = new Array<PunchDataModel>();
  finalArray: any;

  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Error handling
  consentErrMsg: string;

  //Alerts
  showErrorAlert: boolean = false;

  //Submit modal
  modalSubmit: NgbModalRef;
  modalOption: NgbModalOptions = {};
  closeResult: string;

  //Upload Files
  myFiles: string[] = [];
  @ViewChild("fileUploader") fileUploader: ElementRef;
  totalFileSize: number;

  //Upload Flags
  showFileLimit: boolean = false;
  showFileSizeLimit: boolean = false;
  showFileSizeMultipleLimit: boolean = false;
  showRequiredUpload: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formatDataService: FormatDataService,
    private praService: PraService,
    private modalService: NgbModal,
    private httpClient: HttpClient
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.params = params;

      //Initialize all variables
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
      console.log(this.currentUser);

      this.punchRecords = JSON.parse(sessionStorage.getItem("punchRecords"));

      //Get formatted version of punch records
      this.getPunchListForSubmission();

      //Modal Options
      this.modalOption.backdrop = "static";
      this.modalOption.keyboard = false;

      //Make sure comments field is not undefined
      if (this.params.Comments == undefined) {
        this.comments = null;
      } else {
        this.comments = this.params.Comments;
      }

      this.finalArray = {
        AssociateEmployeeID: parseInt(this.params.AssociateEmployeeID),
        AssociateEmployeeName: this.params.AssociateEmployeeName,
        StoreID: parseInt(this.params.StoreID),
        RequestorEmployeeID: parseInt(this.params.RequestorEmployeeID),
        RequestorEmployeeName: this.params.RequestorEmployeeName,
        TodayDate: this.params.TodayDate,
        SelectedWeek: this.formatDataService.formatSelectedWeekToSubmit(
          this.params.SelectedWeek
        ),
        Comments: this.comments,
        State: null,
        RegionCode: null,
        HomeStore: parseInt(this.params.HomeStore),
        PunchRecords: this.punchRecordsList,
      };

      console.log(this.finalArray);
    });
  }

  getPunchListForSubmission() {
    this.punchRecordsList = [];

    for (let index in this.punchRecords) {
      this.punchRecordsList.push(new PunchDataModel(this.punchRecords[index]));
    }

    console.log(this.punchRecordsList);
  }

  submitPRARequest(modal) {
    this.loading = true;
    const result = this.praService
      .submitPRARequest(this.finalArray)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.isSuccess) {
            console.log("success!");
            this.modalSubmit = this.modalService.open(modal, this.modalOption);
            this.modalSubmit.result.then(
              (result) => {
                this.closeResult = `Closed with: ${result}`;
              },
              (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
            );
          } else {
            if (data.ErrMessage) {
              this.consentErrMsg = data.ErrMessage;
              this.showErrorAlert = true;
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            } else {
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              this.showErrorAlert = true;
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          if (error.status === 401 || error.status === 500) {
            this.loading = false;
            console.log("error status");
            alert("An error occured. Please contact PAWS for help.");
          } else {
            this.loading = false;
            console.log(
              "Something went wrong, please contact your administrator:" + error
            );
            alert("An error occured. Please contact PAWS for help.");
          }
        }
      );
  }

  //POST for Super Admin
  submitPRARequestSuperAdmin(modal) {
    this.loading = true;

    //Step 1: Submit PRA Request
    this.praService
      .submitPRARequest(this.finalArray)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.isSuccess) {
            console.log("Step 1: Submit PRA Request Successful");

            //Step 2: Get PRA Requests to retrieve the Request ID for uploading document
            this.praService
              .getPRARequestsEID(
                this.currentUser.userId,
                this.currentUser.employeeId,
                this.currentUser.payrolladmin,
                this.currentUser.opsLevel,
                null,
                null,
                moment().format("MM/DD/YYYY"),
                moment().format("MM/DD/YYYY"),
                null,
                parseInt(this.params.AssociateEmployeeID)
              )
              .pipe(first())
              .subscribe(
                (data) => {
                  console.log("Step 2: Get PRA requests successful");
                  console.log(data);
                  console.log(
                    _.orderBy(data, "PRARequestID", "desc")[0].PRARequestID
                  );
                  console.log(
                    _.orderBy(data, "PRARequestID", "desc")[0].EmployeeID
                  );
                  let requestID = _.orderBy(data, "PRARequestID", "desc")[0]
                    .PRARequestID;
                  let subjectEID = _.orderBy(data, "PRARequestID", "desc")[0]
                    .EmployeeID;

                  //Step 3: Upload documents

                  //Prep upload files
                  const frmData = new FormData();
                  for (var i = 0; i < this.myFiles.length; i++) {
                    frmData.append("uploadDocument", this.myFiles[i]);
                  }
                  console.log(frmData);

                  //Begin upload
                  this.httpClient
                    .post<any>(
                      `${environment.serverUrl}/api/Data/UploadDocuments?RequestID=${requestID}&SubjectEid=${subjectEID}&AuditEid=${this.currentUser.employeeId}`,
                      frmData
                    )
                    .subscribe(
                      (data) => {
                        this.loading = false;
                        console.log("Step 3: Upload document successful");
                        // SHOW A MESSAGE RECEIVED FROM THE WEB API.
                        console.log(data);
                        //Show Modal
                        this.modalSubmit = this.modalService.open(
                          modal,
                          this.modalOption
                        );
                        this.modalSubmit.result.then(
                          (result) => {
                            this.closeResult = `Closed with: ${result}`;
                          },
                          (reason) => {
                            this.closeResult = `Dismissed ${this.getDismissReason(
                              reason
                            )}`;
                          }
                        );
                      },
                      (error) => {
                        this.loading = false;
                        console.log(error.message); // Show error, if any.
                      }
                    );
                },
                (error) => {
                  this.loading = false;
                  console.log(error.message); // Show error, if any.
                }
              );
          } else {
            if (data.ErrMessage) {
              this.loading = false;
              this.consentErrMsg = data.ErrMessage;
              this.showErrorAlert = true;
              console.log(this.consentErrMsg);
            } else {
              this.loading = false;
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              this.showErrorAlert = true;
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          if (error.status === 401 || error.status === 500) {
            this.loading = false;
            console.log("error status");
            alert("An error occured. Please contact PAWS for help.");
          } else {
            this.loading = false;
            console.log(
              "Something went wrong, please contact your administrator:" + error
            );
            alert("An error occured. Please contact PAWS for help.");
          }
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  viewPunchRecords() {
    this.router.navigate(["/view-adjustment-records"]);
    this.modalSubmit.close();
  }

  back() {
    this.router.navigate(["/new-request"], {
      queryParams: {
        AssociateEmployeeID: this.params.AssociateEmployeeID,
        AssociateEmployeeName: this.params.AssociateEmployeeName,
        StoreID: this.params.StoreID,
        RequestorEmployeeID: this.params.RequestorEmployeeID,
        RequestorEmployeeName: this.params.RequestorEmployeeName,
        TodayDate: this.params.TodayDate,
        SelectedWeek: this.params.SelectedWeek,
        Comments: this.params.Comments,
        BusinessDate: this.params.BusinessDate,
        PunchInHour: this.params.PunchInHour,
        PunchInMinute: this.params.PunchInMinute,
        PunchOutHour: this.params.PunchOutHour,
        PunchOutMinute: this.params.PunchOutMinute,
        Index: this.params.Index,
        StoreIndex: this.params.StoreIndex,
        PraWeekIndex: this.params.PraWeekIndex,
        BusinessDateIndex: this.params.BusinessDateIndex,
        IsWeekly: this.params.IsWeekly,
        TotalHours: this.params.TotalHours,
      },
    });

    if (this.modalSubmit !== undefined) {
      this.modalSubmit.close();
    }
  }

  backToRequestPage() {
    this.modalSubmit.close();
    this.router.navigate(["/new-request"]);
  }

  //Upload document for super admin
  getFileDetails(e) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    this.showRequiredUpload = false;
    console.log(e);
    console.log(e.target.files);
    console.log(`Total size: ${_.sumBy(e.target.files, "size")}`);
    console.log(this.myFiles);
    for (var i = 0; i < e.target.files.length; i++) {
      let currentTotal = _.sumBy(this.myFiles, "size") + e.target.files[i].size;
      //get current file size total
      console.log(currentTotal);
      //Don't allow file names greater than 50 characters
      if (e.target.files[i].name.length > 50) {
        console.log("File character too long");
        this.showFileLimit = true;
      } else if (currentTotal > 2000000) {
        this.showFileSizeMultipleLimit = true;
      } else if (e.target.files[i].name.size > 2000000) {
        this.showFileSizeLimit = true;
      } else {
        this.myFiles.push(e.target.files[i]);
        this.showFileLimit = false;
        this.showFileSizeLimit = false;
        this.showFileSizeMultipleLimit = false;
        this.showRequiredUpload = false;
      }
    }
    console.log(this.myFiles);
    console.log(`Total my files: ${_.sumBy(this.myFiles, "size")}`);
    this.totalFileSize = _.sumBy(this.myFiles, "size");
  }

  removeFile(index) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    //remove file from list
    const removeFile = this.myFiles;
    removeFile.splice(index, 1);
    this.myFiles = removeFile;
    console.log(this.myFiles);
    //recalculate total file size
    this.totalFileSize = _.sumBy(this.myFiles, "size");
  }

  checkUpload(modal) {
    this.showRequiredUpload = false;

    if (this.myFiles.length > 0) {
      this.showRequiredUpload = false;
      this.submitPRARequestSuperAdmin(modal);
    } else {
      console.log("no files");
      this.showRequiredUpload = true;
    }
  }
}
